import { useCallback, useEffect, useState } from 'react';
import useRequest from 'hooks/useRequest';

// Hook para gestionar las certificaciones MINVU de un equipo. Idempotente
// contra `/equipos/:idEquipo/certificaciones` y `/certificaciones/:id`.
export function useCertificaciones(idEquipo) {
  const [certificaciones, setCertificaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { request } = useRequest();

  const refresh = useCallback(async () => {
    if (!idEquipo) return [];
    setLoading(true);
    setError(null);
    try {
      const data = await request(`/equipos/${idEquipo}/certificaciones`, 'GET');
      const rows = Array.isArray(data) ? data : [];
      setCertificaciones(rows);
      return rows;
    } catch (err) {
      setError(err);
      return [];
    } finally {
      setLoading(false);
    }
  }, [idEquipo, request]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const create = useCallback(
    async (payload) => {
      const res = await request(`/equipos/${idEquipo}/certificaciones`, 'POST', payload);
      await refresh();
      return res;
    },
    [idEquipo, request, refresh]
  );

  const update = useCallback(
    async (id, payload) => {
      const res = await request(`/certificaciones/${id}`, 'PUT', payload);
      await refresh();
      return res;
    },
    [request, refresh]
  );

  const remove = useCallback(
    async (id) => {
      await request(`/certificaciones/${id}`, 'DELETE');
      await refresh();
    },
    [request, refresh]
  );

  return { certificaciones, loading, error, refresh, create, update, remove };
}
